import { render, staticRenderFns } from "./exchange-rate-results.pug?vue&type=template&id=b8357578&scoped=true&lang=pug&external"
import script from "./exchange-rate-results.js?vue&type=script&lang=js&external"
export * from "./exchange-rate-results.js?vue&type=script&lang=js&external"
import style0 from "./exchange-rate-results.scss?vue&type=style&index=0&id=b8357578&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8357578",
  null
  
)

export default component.exports